import { render, staticRenderFns } from "./PublicationStorageModal.vue?vue&type=template&id=5938bfe4&"
import script from "./PublicationStorageModal.vue?vue&type=script&lang=js&"
export * from "./PublicationStorageModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports